import axios from "axios";
import { BASE_URL } from "../../constants/constant";
import { put, takeEvery } from "redux-saga/effects";
import * as types from "../../constants/types";

function* getCompany(actions) {
  const { error } = actions;
  try {
    const res = yield axios.get(`${BASE_URL}/companies?limit=100`);
    yield put({
      type: types.GET_COMPANY_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    yield put({
      type: types.GET_COMPANY_FAIL,
      error: error,
    });
  }
}

export function* watchGetCompany() {
  yield takeEvery(types.GET_COMPANY_BEGIN, getCompany);
}
